import { useMutation, useQueryClient } from "@tanstack/react-query";

import { savePermit } from "../../services/permits";

import { ISavePermit } from "../../interfaces/services";

import useToast from "../useToast";

export interface IPayload {
    payload: ISavePermit;
    setIsProcessing: Function;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useSavePermit = () => {
    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await savePermit(data.payload);
    };

    return useMutation({
        mutationFn,
        onSuccess: async (response: IResponse, variables: IPayload) => {
            if (response) {
                addToast({
                    type: 'success',
                    title: 'Permit record saved successfully.',
                });

                queryClient.invalidateQueries({ queryKey: ['foreign_worker_immigration_docs'] });
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSavePermit;